import React from "react";
import classes from "./text.module.css";

const TextItem = (props) => {
    return (
        <div className={classes.textItem}>
            <img src={props.url} alt={props.alt} className={classes.textImg}/>
            <h4>{props.post.title}</h4>
            <p>{props.post.body}</p>
        </div>
    )
}

export default TextItem;